import { BasePageComponent } from '@/components/base/BasePageComponent';
import { ConnectornHelper } from '@/helpers/connector.helper';
import { AppConfigService } from '@/services/app-config.service';
import { NavService } from '@/services/nav.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Connector, ConnectorCode } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { ConnectorUserComponent } from '../../components/connector-user/connector-user.component';
import { NgIf } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { PageTitleComponent } from '../../components/page-title/page-title.component';

@Component({
    selector: 'app-connectors',
    templateUrl: './connectors.component.html',
    styleUrls: ['./connectors.component.scss'],
    standalone: true,
    imports: [PageTitleComponent, MatTabsModule, NgIf, ConnectorUserComponent]
})
export class ConnectorsComponent extends BasePageComponent implements OnInit, OnDestroy {
  public connectorKwFrance: Connector = null;
  public connectorKwFranceDisplayName: string;
  ConnectorCode = ConnectorCode;

  private connectorsAvailableSub = new Subscription();

  constructor(
    private appConfigService: AppConfigService,
    private connectorHelper: ConnectornHelper,
    protected route: ActivatedRoute,
    protected navService: NavService
  ) {
    super(route, navService);
  }

  ngOnInit(): void {
    this.connectorsAvailableSub = this.appConfigService.availableConnectorsObs.subscribe((connectors) => {
      connectors.forEach((c) => {
        switch (c.code) {
          case ConnectorCode.KWFRANCE:
            this.connectorKwFrance = c;
            this.connectorKwFranceDisplayName = this.connectorHelper.getConnectorDisplayName(c.code);
            break;
          default:
            break;
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.connectorsAvailableSub.unsubscribe();
  }
}
